<alaris-dialog
		[closeAction]="close.bind(this)"
		[confirmAction]="confirm.bind(this)"
		[confirmButtonText]="'actions.yes' | translate"
		size="md"
		class="removingDialog">
	<h4 slot="header">
		{{ 'sources.close_confirmation_title' | translate }}
	</h4>
</alaris-dialog>